import type { SVGProps } from "react";

export interface TableSearchIconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
    name: "reset" | "search";
    size?: number;
}

/** 与 zhihao-ui-react Table 查询栏一致的搜索、重置图标。 */
export function TableSearchIcon({ name, size = 16, ...props }: TableSearchIconProps) {
    const path =
        name === "search"
            ? "M448 43.712a404.288 404.288 0 1 0 262.4 711.872l156.736 156.8a32 32 0 0 0 45.248-45.248l-156.8-156.8A404.288 404.288 0 0 0 448 43.712zM126.976 448a321.088 321.088 0 1 1 642.112 0A321.088 321.088 0 0 1 126.976 448zM448 214.4c-58.56 0-111.68 23.808-150.08 62.144a41.6 41.6 0 0 0 58.88 58.88C380.16 312 412.288 297.6 448 297.6c35.712 0 67.84 14.4 91.264 37.76a41.6 41.6 0 0 0 58.88-58.816c-38.4-38.4-91.52-62.144-150.144-62.144z"
            : "M217.856 217.856a416 416 0 1 1 0 588.288 32 32 0 1 1 45.248-45.248 352 352 0 1 0 0-497.792c-15.808 15.808-40.768 42.816-63.296 67.584H320a32 32 0 1 1 0 64H128a32 32 0 0 1-32-32v-192a32 32 0 1 1 64 0v108.672c20.544-22.528 42.688-46.4 57.856-61.504z";

    return (
        <svg
            aria-hidden="true"
            data-table-search-icon={name}
            fill="currentColor"
            height={size}
            viewBox="0 0 1024 1024"
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d={path} />
        </svg>
    );
}
